var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[(this.isLogin == 'true')?_c('el-container',[_c('el-aside',{attrs:{"width":"null"}},[_c('Aside')],1),_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',[_c('RouterView')],1)],1)],1):_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }